var map = {
	"./lv1.png": "667d",
	"./lv2.png": "8da9",
	"./lv3.png": "0589",
	"./lv4.png": "15f7",
	"./lv5.png": "3422",
	"./lv6.png": "b63a",
	"./lv7.png": "4c6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbbf";